import { debugRoot } from '../../../../styles/debugStyles';
var listStyles = {
  root: function root(_ref) {
    var p = _ref.props;
    return Object.assign({}, p.debug && debugRoot(), {
      display: p.horizontal ? 'inline-flex' : 'block'
    }, (p.as === 'ul' || p.as === 'ol') && {
      listStyle: 'none',
      padding: 0,
      margin: 0
    });
  }
};
export default listStyles;